import _ from 'underscore'
import CheckoutService from '../../services/CheckoutService'

const actions = {

  nextStep ({commit, getters}) {
    commit('clearRegisterFieldErrors')
    let currentStep = getters.getCurrentStep

    if (currentStep === 1) {
      let errorFields = []
      _.each(getters.getRegisterFields, (value, key) => {
        if ((key !== 'houseNumberAdd' && key !== 'contactMiddleName' && key !== 'chamberOfCommerceNumber' && key !== 'vatNumber' && key !== 'contactPhoneNumber') && value === '') {
          errorFields.push(key)
        }
      })

      if (errorFields.length > 0) {
        commit('setValidationErrorFields', errorFields)
      } else {
        commit('nextStep')
      }

    } else if (currentStep === 2) {
      commit('createOrder')
      CheckoutService.createOrder(getters.getRegisterFields)
        .then((res) => {
          commit('createOrderSuccess')
          window.location.replace(res.body.payment_url)
        })
        .catch(() => {
          commit('createOrderError')
        })
    }
  }
}

export default actions
